import Toast from "./Toast";
import { useToast } from "@/hooks/useToast";
import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  id: string;
  kind?: "anime" | "news";
  className?: string;
  compact?: boolean;
}

export default function FavoriteButton({ id, kind = "anime", className = "", compact = false }: FavoriteButtonProps) {
  const { isFavorite, toggle } = useFavorites(kind);
  const { message, show } = useToast();
  const active = isFavorite(id);

  const handleClick = () => {
    toggle(id);
    show(active ? "已取消收藏" : "已加入收藏列表");
  };

  return (
    <>
      <button
        type="button"
        onClick={handleClick}
        className={`inline-flex items-center justify-center gap-2 rounded-md text-sm font-medium transition-colors cursor-pointer whitespace-nowrap ${
          compact ? "w-10 h-10" : "px-5 h-11"
        } ${
          active
            ? "bg-primary-500 text-background-50 hover:bg-primary-600"
            : "border border-background-300 text-foreground-800 hover:border-primary-300 hover:text-primary-600"
        } ${className}`}
        aria-pressed={active}
        aria-label={active ? "取消收藏" : "收藏"}
      >
        <i className={active ? "ri-heart-fill text-lg" : "ri-heart-line text-lg"} />
        {!compact && (active ? "已收藏" : "收藏")}
      </button>
      <Toast message={message} />
    </>
  );
}